import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">CtheNature</h3>
            <p className="footer-description">
              Professionele wandelcoaching om je te helpen groeien en jezelf te ontdekken
              door de kracht van wandelen in de natuur.
            </p>
            <div className="social-links">
              <a
                href="https://www.instagram.com/c_the_nature/"
                className="social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">Diensten</h4>
            <ul className="footer-links">
              <li><Link to="/diensten">Kennismakingsgesprek</Link></li>
              <li><Link to="/diensten">Kickstart traject</Link></li>
              <li><Link to="/diensten">Duurzaam traject</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">Contact</h4>
            <div className="contact-info">
              <div className="contact-item">
                <Mail size={16} />
                <span>cthenature@outlook.com</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Nederland</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 CtheNature. Alle rechten voorbehouden.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/voorwaarden">Voorwaarden</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
